const C = "VIEW_PKL_OF_PRODUCTION";

export default {
    CHANGE_PACKING_DETAIL: `${C}_CHANGE_PACKING_DETAIL`,
    CHANGE_EMPTY_PACKING: `${C}_CHANGE_EMPTY_PACKING`,
    CHANGE_STYLE_ACTIVE: `${C}_CHANGE_STYLE_ACTIVE`,
}